import { useRouter } from "next/router";
import React, { useState } from "react";
import PageBuilder from "./PageBuilder";
import ParagraphIndex from "./ParagraphIndex";
import { Container, Aside, Content } from "./styles";
import CookiebotPage from "@/components/CookiebotPage";

type Props = {
  paragraphIndex: any[] | null;
  pageBuilder: any[] | null;
};

const Corporate: React.FC<Props> = (props) => {
  const { paragraphIndex, pageBuilder } = props;
  const router = useRouter();

  const [activeSectionId, setActiveSectionId] = useState<string | undefined>(
    () => {
      if (typeof window !== "undefined") {
        return window.location.hash?.replace(/^#/, "");
      }
    }
  );

  return (
    <>
      <Container $hasIndex={paragraphIndex !== null}>
        {paragraphIndex && (
          <Aside>
            <ParagraphIndex
              paragraphIndex={paragraphIndex}
              activeSectionId={activeSectionId}
            />
          </Aside>
        )}
        <Content $hasIndex={paragraphIndex !== null}>
          {pageBuilder && (
            <PageBuilder
              blocks={pageBuilder}
              hasIndex={paragraphIndex !== null}
              onParagraphEntry={(id: string) => setActiveSectionId(id)}
            />
          )}
          {router.query.slug === "cookie-policy" && <CookiebotPage />}
        </Content>
      </Container>
    </>
  );
};

export default Corporate;
